module.exports = __webpack_public_path__ + "static/media/posture2.aa4210d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/posture2.jpg
// module id = 196
// module chunks = 0